import React from "react";

import Hero from "../component/Hero";
import Tools from "../component/Tools";
import Marketing from "../component/Marketing";
import AboutUs from "../component/AboutUs";
import ContactUs from "../component/ContactUs";

import './Main.css';

const Main = () => {
 return(
     <div className="main-container">
         <Hero />
         <Tools />
         <Marketing />
         <AboutUs />
         <ContactUs />
     </div>
 )
}

export default Main;